import React from 'react';
import { useNavigate } from 'react-router-dom';
import Conversations from '../../components/conversations/conversations';
import MobileLayout from '../../components/layout/MobileLayout';
import { fetchConversationDetails } from '../../utils/axiosApiRequest';
import { useTranslation } from 'react-i18next';

const MobileConversationsPage = ({
  recording,
  selectedConversation,
  startNewConversation,
  setSelectedConversation,
  setShowControls,
  setMessages,
  setSummary,
  setSummaryId,
  setAudioFilename,
  setPromptTemplates,
  setSelectedPrompt,
  setLanguage,
  setAudioReady,
  setWordCount,
  setRecordingDuration,
  triggerUpdateConversationId,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleConversationSelect = async (conversation) => {
    if (conversation && conversation.id) {
      setSelectedConversation(conversation);
      
      // Check if this conversation has any audio or summary
      try {
        const details = await fetchConversationDetails(conversation.id);
        
        if (!details.audio_filename || details.transcript.length === 0) {
          console.log('No recording available, navigating to recording page');
          
          setShowControls(true);
          setMessages([]);
          setWordCount(0);
          setRecordingDuration(0);
          
          navigate(`/recording/${conversation.id}`);
        } else {
          console.log('Recording available, navigating to summary page');
          navigate(`/summary/${conversation.id}`);
        }
      } catch (error) {
        console.error('Error checking conversation details:', error);
        navigate(`/summary/${conversation.id}`);
      }
    } else {
      setSelectedConversation(conversation);
    }
  };

  const handleNewConversation = async () => {
    const newConversation = await startNewConversation();
    setSelectedConversation(newConversation);
    setShowControls(true);
    navigate(`/recording/${newConversation.id}`);
  };

  return (
    <MobileLayout title={t('mobileTitle.conversations')}>
      <Conversations
        selectedConversation={selectedConversation}
        setSelectedConversation={handleConversationSelect}
        startNewConversation={handleNewConversation}
        setShowControls={setShowControls}
        recording={recording}
        setMessages={setMessages}
        setSummary={setSummary}
        setSummaryId={setSummaryId}
        setAudioFilename={setAudioFilename}
        setPromptTemplates={setPromptTemplates}
        setSelectedPrompt={setSelectedPrompt}
        setLanguage={setLanguage}
        setAudioReady={setAudioReady}
        triggerUpdateConversationId={triggerUpdateConversationId}
        isMobile={true}
      />
    </MobileLayout>
  );
};

export default MobileConversationsPage; 